/**
 * 用户关系类型常量
 */
export const RELATION_TYPE = {
  DEFAULT: 0, // 无关系
  FOLLOWED: 1, // 关注
  BE_FOLLOWED: 2, // 被关注
  FRIEND: 3, // 好友（相互关注）
  BLOCKED: 4, // 拉黑
  BE_BLOCKED: 5, // 被拉黑
  ACTIVE_FRIEND: 6, // 主动加好友
  PASSIVE_FRIEND: 7, // 被加好友
  BOTH_BLOCKED: 8, // 互相拉黑
  BOTH_FOLLOWED: 9, // 相互关注
}

/**
 * 性别常量
 */
export const GENDER = {
  MALE: 0, // 男性
  FEMALE: 1, // 女性
}

/**
 * 主播在线状态
 */
export const ONLINE_STATUS = {
  OFFLINE: 0, // 离线
  ONLINE: 1, // 在线
  BUSY: 4, // 忙碌
  ACTIVE: 5, // 活跃
  PARTY_ROOM: 6, // 语音房/派对房
  SHOW_ROOM: 7, // 秀场房间
}

/**
 * 用户角色常量
 */
export const MEMBER_ROLE = {
  COMMON: 0, // 普通用户
  ANCHOR: 1, // 主播
  OPERATOR: 2, // 运营、客服等
  WHITE_LIST: 10, // 白名单用户
}

/**
 * VIP 状态常量
 */
export const VIP_STATUS = {
  NO: 0, // 非VIP
  YES: 1, // VIP
  HIDE: -1, // 隐藏 VIP 相关功能
}
